import {ErrorHandler, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {catchError} from 'rxjs/operators';
import {ObservableInput} from 'rxjs';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  protected classroom: ClassroomStateModel;
  constructor(
    private http: HttpClient,
    private store: Store
  ) {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }

  public handleError(error: any): void {
    let message: string = '';
    if (error.stack) {
      message = error.stack;
    } else if (typeof error === 'object') {
      message = JSON.stringify(error);
    } else {
      message = error.toString();
    }

    console.error(error);
    this.http.post(`${this.classroom.vcrURL}/classroom/client-error`, message)
      .pipe(catchError((httpError: any): ObservableInput<void> => {
        console.error('Can\'t log client error on server.', httpError);
        return;
      }))
      .subscribe();
  }
}
